import { Validators } from '@angular/forms';
import { TableCols } from '../interfaces/static-data';

export const LANGUAGE: TableCols[] = [
  {
    key: 'isoCode',
    displayValue: 'ISO Code',
    validators: [Validators.required],
  },
  {
    key: 'description',
    displayValue: 'Language',
    validators: [Validators.required],
  },
  {
    key: 'status',
    displayValue: 'Status',
    type: 'select',
    items: [
      {
        id: 'Active',
        displayValue: 'Active',
      },
      {
        id: 'Inactive',
        displayValue: 'Inactive',
      }
    ],
    validators: [Validators.required],
  },
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'updatedOn',
    displayValue: 'Updated On',
    hideOnForm: true
  }
];
